<template>
  <div class="agreement-page">
    <div class="top">用户协议</div>
    <div class="titlepage">
      <div class="doc-scroll" ref="scroll">
        <div class="doc-heading" id="NAVaaa">
          <span class="title">用户服务协议</span>
        </div>
        <div class="doc-body">
          <pre class="conta">{{ yhxy }}</pre>
        </div>
        <div class="doc-heading doc-heading-gap" id="NAVbbb">
          <span class="title">隐私政策</span>
        </div>
        <div class="doc-body">
          <pre class="conta">{{ ysxy }}</pre>
        </div>
      </div>
    </div>
    <div class="botom">
      <div class="xieyi">
        <span class="jh-link" @click="scrollTo('NAVaaa')">《用户服务协议》、</span>
        <span class="jh-link" @click="scrollTo('NAVbbb')">《隐私政策》</span>
      </div>
      <div class="btn-row">
        <van-button
          v-if="num > 0"
          type="danger"
          color="#dd0000"
          round
          block
          disabled
          >（{{ num }}）同意并继续</van-button
        >
        <van-button
          v-else
          type="danger"
          color="#dd0000"
          round
          block
          @click="goadd"
          >同意并继续</van-button
        >
        <van-button
          v-if="num === 0"
          type="danger"
          plain
          color="#dd0000"
          round
          block
          class="back-btn"
          @click="goback"
          >返回</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      yhxy: "",
      ysxy: "",
      num: 5,
      timer: null,
    };
  },
  mounted() {
    this.getimfo();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    getimfo() {
      this.fetchget("/home/license").then((res) => {
        if (res.code > 0) {
          this.yhxy = res.data.yhxy || "";
          this.ysxy = res.data.ysxy || "";
          this.timer = setInterval(() => {
            if (this.num <= 0) {
              clearInterval(this.timer);
              this.timer = null;
              return;
            }
            this.num -= 1;
          }, 1000);
        } else {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        }
      });
    },
    goadd() {
      localStorage.setItem("agreeSomeOne", "true");
      sessionStorage.setItem("needSearchAfterAgree", "1");
      this.goback();
    },
    goback() {
      this.$router.back();
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },
};
</script>

<style lang="scss" scoped>
$brand: #dd0000;
$bg: #f3f5f9;
$text: #0f172a;
$muted: #64748b;
$border: #e2e8f0;
$radius: 10px;
$shadow: 0 4px 16px rgba(15, 23, 42, 0.04);

.agreement-page {
  min-height: 100vh;
  background: $bg;
}

.top {
  width: 100%;
  height: 44px;
  background-color: $brand;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}

.titlepage {
  padding: 16px 16px 0;
  height: calc(100vh - 44px - 140px);
  box-sizing: border-box;
}

.doc-scroll {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.doc-heading {
  text-align: center;
  padding: 8px 0 12px;
}

.doc-heading-gap {
  margin-top: 20px;
}

.title {
  font-weight: 700;
  font-size: 18px;
  color: $text;
}

.doc-body {
  padding: 14px;
  background: #fff;
  border-radius: $radius;
  border: 1px solid $border;
  box-shadow: $shadow;
}

.conta {
  margin: 0;
  font-family: inherit;
  font-size: 14px;
  color: #475569;
  line-height: 1.75;
  white-space: pre-wrap;
  word-break: break-word;
}

.botom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding: 8px 16px calc(10px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid $border;
  box-sizing: border-box;
}

.xieyi {
  text-align: center;
  margin: 0 0 8px;
  line-height: 1.5;
}

.jh-link {
  color: $brand;
  font-size: 13px;
  cursor: pointer;
}

.btn-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.back-btn {
  margin-top: 0;
}
</style>
